const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_EVALUATION":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
